<template>
      <TheFooter>
        <div>
          <!--footer-->
          <a href="https://soch3d.com">Soch3d</a>
          <span class="ml-1">&copy; 2019 creativeLabs.</span>
        </div>
        <div class="ml-auto">
          <span class="mr-1">Powered by</span>
          <a href="https://soch3d.com">Soch3d</a>
        </div>
      </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
  name: 'DefaultFooter',
  components: {
    TheFooter
  },
}
</script>
